{
  "about": {
    "title": "Um Spring Boot Admin",
    "label": "Um"
  }
}
